<template>
  <div>
    <div class="container-top">
      <div class="container-title">
        <span>ALL Accounts</span>
        <span>Total {{ total }} accounts (Show 10,000 latest records)</span>
      </div>

      <div class="container-selectPage">
        <div class="change-page">
          <span>Show</span>
          <div @click.stop="showRecordPage=!showRecordPage" class="change-page-num">
            <span>{{nowRecordPage}}</span>
            <img src="../../images/transtion/arrow-bottom.png"/>
            <div v-show="showRecordPage" class="change-page-num-click">
              <span v-for="(item,index) in recordPage" :key="index"  @click.stop="actionSelectPage(item)">{{item.num}}</span>
            </div>
          </div>
          <span>Records</span>
        </div>
        <paginationSp :config="cfg_pagination" @reloadList="getList()" class="py-3"/>
      </div>

    </div>
    <div class="bg-card mt-4">
      <table class="main-table w-100 text-right">
        <tr class="text-break">
          <td class="pl-4 text-left text-middle-bond" style="width: 35%" >
            ADDRESS
          </td>
          <td class="text-left text-middle-bond" style="width: 30%">
            MAPO BALANCE
          </td>
          <td class="text-left text-middle-bond" style="width: 30%">
            Percentage
          </td>

        </tr>
        <tr v-for="(item,index) in data_onshow" :key="index" class="hover-bg transTable">
          <td class="mb-none text-left d-flex flex-row align-items-center">
            <div class="ml-4 trans-icon" style="width: 42px;height: 42px">
              <div class="token-icon-img"></div>
            </div>
            <div class="trans-td-text ml-3" style="color:#E44E3A;">
              <router-link :to="`/address/${item.address}`">{{item.address}}</router-link>
            </div>
          </td>
          <td class="text-left">
            <div class="trans-td-text">
              {{item.balance}}
            </div>
          </td>
          <td class="text-left">
            <div class="trans-td-text">{{ (item.estimate / 1000000000 * 100).toFixed(2)}}%</div>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import Decimal from 'decimal.js'
import { getSortAddress } from '@/util/index'
import paginationSp from '@/views/_comp/pagination_sp.vue'
// import btnSortArr from '@/views/_comp/btn_sort_arr.vue'

export default {
  name: 'accountTable',
  components: {
    paginationSp,
    // btnSortArr,
  },
  props: [
    // 'data',
    'page',
    'cfg',
  ],
  data() {
    return {
      total:0,
      option1:10,
      showRecordPage:false,//显示数据tab
      nowRecordPage:25,//当前显示数据
      recordPage:[
        {num:25},
        {num:50},
        {num:75},
        {num:100}
      ],//一页多少数据
      showImg:0,
      cfg_pagination: {
        'page_size': 25, //每页条目数量
        'page_current': 1, // 当前页
        'count_items': 0, //总个数，和总页数选填其一
        'btn_num': 5, // 按钮个数
        'turnpage_top': true, // 翻页时操作滚动置顶
        'count_pages':0, //总页数，和个页数选填其一 // 默认请给 0 值-便于首次加载时不露出分页器
      },
      data_onshow: [
        {}
      ],

      contract:'',
      bykey:'',
      pairlist:''
    }
  },
  computed: {},
  watch: {},
  methods: {
    getSortAddress(val){
      return getSortAddress(val)
    },
    //选择当前一页多少数据
    actionSelectPage(item) {
      let v = this
      v.nowRecordPage=item.num
      v.cfg_pagination.page_size=item.num
      v.showRecordPage=false
      // console.log(v.showRecordPage)
      v.initData()
    },
    initData(){
      let v = this
      // if(!v.data)return

      v.cfg_pagination.page_current = 1

      // 过滤数据
      v.getList()
    },

    async getList(){
      let v = this
      // 过滤条目
      let start = v.cfg_pagination.page_current
      let end = v.cfg_pagination.page_size
      // v.data_onshow = v.data.slice(start, end)
      let result= await v.api('accountList',{
        page: start,
        size: end,
      },{
        vue: v,
        key_data: 'data',
      })
      if (result.code==200) {
        v.data_onshow=result.data.accountsList
        v.data_onshow.filter(item=>{
          // console.log(item.tokenBalance,'=====')
          // console.log('====',item.balance)
          item.balance=new Decimal(item.balance).div(Math.pow(10,18)).toFixed(6)
          // console.log('1111',new Decimal(item.balance).div(Math.pow(10,18)).toFixed(6))
        })
        v.total = result.data.total
      }
      // 计算页码
      if(v.total < 10000){
        v.cfg_pagination.count_pages = Math.ceil(v.total/v.cfg_pagination.page_size)
      }else{
        v.cfg_pagination.count_pages = Math.ceil(10000/v.cfg_pagination.page_size)
      }

    },
  },
  created() {
    this.initData()
  },
  mounted() {
  },
  //beforeDestroy() {},
  //update() {},
  //activited() {},
  //beforeRouteUpdate() {},
  //filters: {},
};
</script>

<style lang="scss" scoped>

.token-icon-img {
  width: 25px;
  height: 20px;
  background: url("../../images/token/account-black.png")no-repeat;
  background-size: 100% auto;
}




</style>
